import React, { useEffect } from "react";
import Modal from "react-modal";
import { marked } from "marked";
import { connect } from "react-redux";

import { shutterbDashboardActions } from "../../../../redux/actions";
import DetailRow from "./DetailRow";

// Modal for showing the details of reels (recap brief)
const ReelDetailsModal = ({
  allReels,
  className,
  isModalOpen,
  handleModalClose,
  reelModalEventId,
  reelModalEventGroupId,
  getReelsByEventId,
  getReelsByEventGroupId,
}) => {
  // Fetch reels when modal opens or when event/group ID changes.
  useEffect(() => {
    if (reelModalEventId) {
      getReelsByEventId(reelModalEventId);
    }
    if (reelModalEventGroupId) {
      getReelsByEventGroupId(reelModalEventGroupId);
    }
  }, [reelModalEventId, reelModalEventGroupId]);

  // Convert markdown/plain text into HTML.
  // Detects if HTML already exists to avoid double-parsing.
  const getFormattedHtml = (text = "") => {
    const isHtml = /<\/?[a-z][\s\S]*>/i.test(text);

    return {
      __html: isHtml ? text : marked.parse(text),
    };
  };

  return (
    <Modal
      isOpen={isModalOpen}
      className={className}
      onRequestClose={handleModalClose}
    >
      <div className="main-con">
        <div className="row">
          {/* Header */}
          <div className="row w-100 header">
            <div className="col-12">recap brief</div>
            <div className="col-12">
              {reelModalEventId || reelModalEventGroupId || 0}
            </div>
          </div>
          {/* Details */}
          <div className="w-100 my-3">
            {/* If reels exist, render them */}
            {allReels?.length > 0 && (
              <>
                {allReels.map((reel) => (
                  <React.Fragment key={reel.id}>
                    <DetailRow label="name:" value={reel.reelName} />
                    <DetailRow label="orientation:" value={reel.orientation} />
                    <DetailRow label="recap type:" value={reel.reelType} />
                    <div className="row w-100">
                      <div className="col-12">
                        <hr />
                      </div>
                    </div>
                  </React.Fragment>
                ))}

                {/* Editing Brief (Markdown + HTML Support) */}
                <div className="row w-100">
                  <div className="col-12 col-md-4 col-lg-3 col-xl-2 py-1 py-md-2 detail-row-heading">
                    editing brief:
                  </div>
                  <div
                    className="col-12 col-md-8 col-lg-9 col-xl-10 py-1 py-md-2 formatted-html"
                    dangerouslySetInnerHTML={getFormattedHtml(
                      allReels[0].description
                    )}
                  />
                </div>
              </>
            )}
          </div>
        </div>

        {/* Close Button */}
        <button onClick={handleModalClose} className="modal-close">
          <img
            alt="crossIcon"
            className="modal-close-img"
            src="/images/simpleCrossWhite.svg"
          />
        </button>
      </div>
    </Modal>
  );
};

// Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  allReels: state.shutterbDashboard.allReels,
});

// Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  getReelsByEventId: (eventId) =>
    dispatch(shutterbDashboardActions.getReelsByEventId(eventId)),
  getReelsByEventGroupId: (eventGroupId) =>
    dispatch(shutterbDashboardActions.getReelsByEventGroupId(eventGroupId)),
});

// mapping action and store the function via props
export default connect(mapStateToProps, mapDispatchToProps)(ReelDetailsModal);
